export const sendPostMessageToParent = (message: any) => {
  window.parent.window.postMessage(message, '*');
};

export const sendPostMessageToIFrame = (frame: any, message: any) => {
  frame?.contentWindow?.postMessage(message, '*');
};
